import React from "react"

function IconFont() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 -4 16 20"><title>text</title><g fill="#000000"><polygon fill="#30659B" points="0,0 0,6 1,6 3,3 6,3 6,13 3,15 3,16 13,16 13,15 10,13 10,3 13,3 15,6 16,6 16,0 "></polygon></g></svg>
  )
}

export default IconFont